import React from "react";
import { Loader2 } from "lucide-react";
import { cn } from "@/lib/format";

const variants = {
  primary:
    "bg-brand-600 text-white hover:bg-brand-700 shadow-brand disabled:bg-brand-600/50",
  secondary:
    "bg-secondary text-secondary-foreground hover:bg-muted border border-border",
  outline:
    "border-2 border-border text-foreground hover:border-brand-500 hover:text-brand-600 bg-transparent",
  ghost: "text-brand-600 hover:bg-accent",
  danger: "bg-destructive text-white hover:opacity-90",
};

export default function Button({
  children,
  variant = "primary",
  loading = false,
  disabled = false,
  className = "",
  size = "md",
  ...props
}) {
  const sizes = {
    sm: "h-10 px-4 text-sm",
    md: "h-12 px-6 text-[15px]",
    lg: "h-14 px-8 text-base",
  };
  return (
    <button
      disabled={disabled || loading}
      className={cn(
        "inline-flex items-center justify-center gap-2 rounded-full font-semibold transition-all duration-200 active:scale-[0.98] disabled:cursor-not-allowed disabled:opacity-60",
        variants[variant],
        sizes[size],
        className
      )}
      {...props}
    >
      {loading && <Loader2 className="h-4 w-4 animate-spin" />}
      {children}
    </button>
  );
}
